import axios from "@/utils/axiosRequest"
// 获取项目
export const getProgram = (news)=>{
    return axios.request({
        url:"/tianwei/selitem",
        method:"POST",
        data:news
    })
}
// 获取项目详情
export const getDetailData = (news)=>{
    return axios.request({
        url:"/tianwei/selectitem",
        method:"POST",
        data:news
    })
}
